import { useEffect, useState } from "react";
import { toast } from "sonner";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { apiGet, apiPost } from "@/services/api";
import { formatPrice } from "@/lib/utils";

type Withdrawal = { id: string; amount: number; status: string; method: string | null; adminNote: string | null; createdAt: string };

export function VendorWithdrawalsPage() {
  const [withdrawals, setWithdrawals] = useState<Withdrawal[]>([]);
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("bank");
  const [note, setNote] = useState("");

  async function load() {
    const d = await apiGet<{ withdrawals: Withdrawal[] }>("/api/vendors/me/withdrawals");
    setWithdrawals(d?.withdrawals ?? []);
  }
  useEffect(() => {
    void load();
  }, []);

  async function request() {
    try {
      await apiPost("/api/vendors/me/withdrawals", { amount: Number(amount), method, note });
      toast.success("Withdrawal requested");
      setAmount("");
      setNote("");
      void load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Could not request withdrawal");
    }
  }

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold">Withdrawals</h2>
      <div className="amazon-card max-w-md space-y-3 p-5">
        <h3 className="font-bold">Request withdrawal</h3>
        <input
          type="number"
          placeholder="Amount (ETB)"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="w-full rounded border border-slate-300 px-3 py-2 dark:border-white/10 dark:bg-white/5"
        />
        <input
          placeholder="Method"
          value={method}
          onChange={(e) => setMethod(e.target.value)}
          className="w-full rounded border border-slate-300 px-3 py-2 dark:border-white/10 dark:bg-white/5"
        />
        <input
          placeholder="Note (optional)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="w-full rounded border border-slate-300 px-3 py-2 dark:border-white/10 dark:bg-white/5"
        />
        <Button onClick={() => void request()}>Request</Button>
      </div>
      <div className="amazon-card divide-y divide-slate-100 dark:divide-white/10">
        {withdrawals.length === 0 && <p className="p-6 text-sm text-slate-500">No withdrawals yet.</p>}
        {withdrawals.map((w) => (
          <div key={w.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-4">
            <div className="min-w-0 flex-1">
              <p className="font-bold">{formatPrice(w.amount)}</p>
              <p className="text-xs text-slate-500 break-words">
                {w.method ?? "—"} · {new Date(w.createdAt).toLocaleDateString()}
                {w.adminNote ? ` · ${w.adminNote}` : ""}
              </p>
            </div>
            <div className="shrink-0 self-start sm:self-center">
              <Badge tone={w.status === "COMPLETED" ? "success" : w.status === "REJECTED" || w.status === "FAILED" ? "deal" : "prime"}>
                {w.status}
              </Badge>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
